import React, {useEffect, useState} from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import {validMail, validString} from "../../validation";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import {restorePassword, setErrorProfile} from "../../reducers/profile/actions";

function ModalRestore({isLoaded, isError, restorePassword, clearError, toggle, setSuccessText, toggleSuccess, isOpen}) {
    const [email, setEmail] = useState('');
    const [prevOpen, setPrevOpen] = useState(false);

    useEffect(() => {
        if (isOpen && isError) {
            clearError();
            alert('Invalid Data');
        }

        if (prevOpen !== isOpen) {
            if (isOpen) {
                initState();
            }
            setPrevOpen(isOpen);
        }
    });

    function initState() {
        setEmail('');
    }

    const handleInputEmail = (evt) => setEmail(evt.target.value);

    const validEmail = () => {
        const str = email.trim();
        return validString(str) && validMail(str)
    };

    const sendForm = () => {
        if (validEmail()) {
            const data = {email: email.trim()},
                successCB = () => {
                    toggle();
                    setSuccessText('Please, check your email');
                    toggleSuccess();
                };
            return restorePassword({data, successCB});
        }
        alert('Invalid Email');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            sendForm();
        }
    };
    return (
        <div>
            <Modal isOpen={isOpen}>
                <ModalHeader toggle={isLoaded ? null : toggle}>Restore</ModalHeader>
                <ModalBody>
                    <Form onSubmit={sendForm}>
                        <FormGroup>
                            <Label for="exampleEmail">Email</Label>
                            <Input type="email" name="email" id="exampleEmail" placeholder="Email"
                                   value={email} onChange={handleInputEmail} onKeyPress={handleKeyPress}/>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <button className={`btn third ${isLoaded ? " disabled" : ''}`}
                            onClick={isLoaded ? null : sendForm}>Send
                    </button>
                    {' '}
                    <button className={`btn first ${isLoaded ? " disabled" : ''}`}
                            onClick={isLoaded ? null : toggle}>Cancel
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

ModalRestore.propTypes = {
    restorePassword: PropTypes.func,
    clearError: PropTypes.func,
    isLoaded: PropTypes.bool,
    isError: PropTypes.bool,
    toggle: PropTypes.func,
    setSuccessText: PropTypes.func,
    toggleSuccess: PropTypes.func,
    isOpen: PropTypes.bool,
};

export default connect(null, (dispatch) => (
    {
        restorePassword: (data) => dispatch(restorePassword(data)),
        clearError: () => dispatch(setErrorProfile(false)),
    })
)(ModalRestore);
